import { render, staticRenderFns } from "./ContainerInfo.vue?vue&type=template&id=af840ad8&lang=pug&"
import script from "./ContainerInfo.vue?vue&type=script&lang=js&"
export * from "./ContainerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports